import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import "react-datepicker/dist/react-datepicker.css";

import Dropzone, { IDropzoneProps } from "react-dropzone-uploader";
import "react-dropzone-uploader/dist/styles.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { Formik, Form, Field, FormikProps, ErrorMessage } from "formik";
import { WithContext as ReactTags } from "react-tag-input";
import * as Yup from "yup";
import Modal from "react-bootstrap/Modal";

import AddImg from "../../../../assets/add-img.svg";
import UploadIcon from "../../../../assets/icons/upload.svg";
import TrashIcon from "../../../../assets/icons/ic_delete.svg";
import RemoveIcon from "../../../../assets/icons/remove.svg";
import SearchIco from "../../../../assets/icons/search.svg";
import LeftArrow from "../../../../assets/icons/left-arrow.png";
import InfoIcon from "../../../../shared/components/icons/InfoIcon";

import "../../index.scss";
import { AlertMsg } from "../../../../shared/components/alert-msg";
import { LoadingItem } from "../../../../shared/components/loading";
import { useToast } from "../../../../shared/context/ToastContext";

import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";

import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";

import { allowNumbersOnly, numberWithCommas } from "../../../../shared/utils";
import DatePicker from "react-datepicker";
import {
  EditableProductAttribute,
  Variant,
} from "../../../../types/ProductTypes";
import {
  buildProductPayload,
  calculateDiscountPercent,
  calculateDiscountedPrice,
  getRequestErrorMessage,
  getProductSubmissionErrors,
  normalizeProductResponseToForm,
  parseMoneyInput,
} from "./productPayload";

import { history } from "../../../../shared/_helpers/history";
import { useParams } from "react-router-dom";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ProductVarianceModal from "../../../../views/Inapp/products/addNew/ProductVarianceModal";
import { ImageDrawer } from "../../../../views/Inapp/products/addNew/ImageDrawer";

const uploadImagesData: any[] = [];
const sizeofFetch = 8;


const LegacyProductImageDrawer = ({
  pageProps,
  showImagesModal,
  catListItems,
  hideProductImgModal,
  tempImages,
}: any) => {
  const [categoryChosen, setCategoryChosen] = useState<any>();
  const [searchTerm, setSearchTerm] = useState("");
  const [categoryToUpload, setUploadCategory] = useState<any>();
  const [productUploadName, setUploadProductName] = useState("");
  const [productNameError, setProductNameError] = useState(true);
  const [productCatError, setProductCatError] = useState(true);
  const [setImagesUploaded, setImagesUploadedStore] = useState<any>([
    ...tempImages,
  ]);
  const [imageData, setImageUploadData] = useState<any>();
  const [hasImageUploaded, setHasImageUploaded] = useState(false);
  const productUploadNameRef = useRef<any>(null);
  const [productUploadOtherNames, setUploadProductOtherNames] = useState<any>(
    [],
  );
  const [uploadOtherNamesTags, setUploadOtherNamesTags] = useState<any>([]);
  const [showUploadAnother, setShowUploadAnother] = useState(false);
  let imagesChosen: any = [];

  useEffect(() => {
    if (imageData) {
      const imageUploadData = new FormData();
      imageUploadData.append("ProductName", imageData.ProductName);
      imageUploadData.append("CategoryName", imageData.CategoryName);
      imageUploadData.append("ImageFile", imageData.ImageFile);
      imageUploadData.append("OtherNames", imageData.OtherNames);

      uploadProductImage({
        pageProps,
        payload: imageUploadData,
        otherNames: imageData.OtherNames,
      }).then(() => {
        setHasImageUploaded(true);
      });
    }
  }, [imageData]);

  useEffect(() => {
    if (
      hasImageUploaded &&
      pageProps.updateProductImageRequest.request_status ===
      "UPLOAD_PRODUCT_PICTURE_SUCCESS"
    ) {
      let imageLink = pageProps.updateProductImageRequest.request_data;
      imagesChosen = [...setImagesUploaded];
      imagesChosen.push({
        index: setImagesUploaded.length + 1,
        url: imageLink.response.fileURL,
        otherNames: imageLink?.response?.otherNames
          ? [...imageLink?.response?.otherNames]
          : [],
        // url: imageLink.response.thumbnail
      });

      let imagesList = [...setImagesUploaded];
      imagesList.push({
        index: setImagesUploaded.length + 1,
        url: imageLink.response.fileURL,
        otherNames: imageLink?.response?.otherNames
          ? [...imageLink?.response?.otherNames]
          : [],
        // url: imageLink.response.thumbnail
      });
      setImagesUploadedStore(imagesList);

      setHasImageUploaded(false);
    }
  }, [hasImageUploaded]);

  const transformImageName = (image: any) => {
    let filename = image;

    if (filename.indexOf("upload-file/") > -1) {
      filename = image.split("upload-file/")[1];
    }
    if (filename.indexOf("thumbnails/") > -1) {
      filename = image.split("thumbnails/")[1];
    }

    return filename;
  };
  const removeImageFromUploads = (chosenImg: any) => {
    let imagesList = [...setImagesUploaded];
    imagesList = imagesList.filter((itemData: any) => {
      return itemData.url !== chosenImg.url;
    });
    setImagesUploadedStore(imagesList);
  };

  const saveSearchFilter = (searchTerm: any) => {
    setCategoryChosen({
      label: null,
      value: null,
    });
    let payload = `page=1&size=${sizeofFetch}${searchTerm ? `&fileName=${searchTerm}` : ""
      }`;
    getImagesGallery({ pageProps, payload });
  };

  const saveChosenCat = (chosenCat: any) => {
    setSearchTerm("");
    setCategoryChosen(chosenCat);
    let payload = `page=1&size=${sizeofFetch}${chosenCat?.label ? `&fileName=${chosenCat.label}` : ""
      }`;
    getImagesGallery({ pageProps, payload });
  };

  const saveUploadCat = (chosenCat: any) => {
    setProductCatError(false);
    setUploadCategory(chosenCat);
  };

  const handleDelete = (i: any) => {
    // this.setState({
    //     tags: this.state.tags.filter((tag, index) => index !== i),
    // });
    setUploadOtherNamesTags(
      uploadOtherNamesTags.filter((tag: any, index: any) => index !== i),
    );
  };

  const handleAddition = (tag: any) => {
    if (productUploadOtherNames.indexOf(tag?.text) === -1) {
      setUploadOtherNamesTags([...uploadOtherNamesTags, tag]);
      setUploadProductOtherNames([...productUploadOtherNames, tag?.text]);
    }
    // this.setState({ tags: [...tags, { id: tags.length + 1, text: tag }] });
  };

  const KeyCodes = {
    comma: 188,
    enter: 13,
  };
  const delimiters = [KeyCodes.comma, KeyCodes.enter];

  const ImageUploadBox = () => {
    const getUploadParams: IDropzoneProps["getUploadParams"] = () => {
      return { url: "https://httpbin.org/post" };
      // return { url: 'https://httpbin.org/post' }
    };

    const handleChangeStatus: IDropzoneProps["onChangeStatus"] = (
      { meta },
      status,
    ) => { };

    const handleSubmit: IDropzoneProps["onSubmit"] = (files: any, allFiles) => {
      // if (productUploadName) {
      //     setProductNameError(false)
      // } else {
      //     setProductNameError(true)
      // }

      // if (categoryToUpload) {
      //     setProductCatError(false)
      // } else {
      //     setProductCatError(true)
      // }

      if (!productNameError && !productCatError) {
        // setProductNameError(true)

        let imageData = {
          ProductName: productUploadNameRef?.current?.value,
          CategoryName: categoryToUpload.value,
          ImageFile: files[0].file,
          OtherNames: productUploadOtherNames,
        };
        setUploadProductName("");
        setImageUploadData(imageData);
      } else {
        setProductNameError(true);
      }

      // allFiles.forEach((f) => f.remove())
    };

    return (
      <div
        className={
          !productUploadNameRef?.current?.value || productCatError
            ? "upload_img_wrap disabled_wrap"
            : "upload_img_wrap"
        }
      >
        <Dropzone
          getUploadParams={getUploadParams}
          onChangeStatus={handleChangeStatus}
          onSubmit={handleSubmit}
          accept="image/*"
          maxFiles={1}
          // disabled={productNameError && productCatError}
          multiple={false}
          canRestart={false}
          canCancel={false}
          // autoUpload={false}
          submitButtonContent="Upload image"
          inputContent={() => {
            return (
              <div className="upload_cnt upload_msg" key={30}>
                <img src={UploadIcon} alt="" />
                {!showUploadAnother && (
                  <div className="upload-txt">Upload photo here</div>
                )}
                {showUploadAnother && (
                  <div className="upload-txt">Upload another photo here</div>
                )}
                <div className="or-txt">or</div>
                <div className="upload-cta">Browse files</div>
              </div>
            );
          }}
          styles={{ dropzone: { minHeight: 200, maxHeight: 250 } }}
        />
      </div>
    );
  };

  return (
    <Modal
      className="upload_images_wrap"
      show={showImagesModal}
      onHide={hideProductImgModal}
    >
      <Modal.Header closeButton>
        <div className="">Upload product image </div>
      </Modal.Header>
      <Modal.Body>
        <Tab.Container defaultActiveKey="mami_gallery">
          <Nav className="other_productinfo_tabs">
            <Nav.Item>
              <Nav.Link eventKey="upload_now">Upload Image</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="mami_gallery">MamiMarket Gallery</Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content className="other_productinfo_tabs_content">
            <Tab.Pane eventKey="upload_now">
              <div>
                <div className="product-info image-info-details">
                  <div className="two-sided">
                    <div className="form-group">
                      <input
                        placeholder="Product name"
                        onChange={(e: any) => {
                          // setUploadProductName(e.target.value)
                        }}
                        onBlur={(e: any) => {
                          if (productUploadNameRef?.current?.value.length < 1) {
                            // if (e.target.value.trim().length < 1) {
                            setProductNameError(true);
                          } else {
                            setProductNameError(false);
                          }
                        }}
                        type="text"
                        // value={productUploadName}
                        ref={productUploadNameRef}
                        name=""
                        id=""
                        className="input-wrap"
                      />
                      {/* {productNameError &&
                                                <div className="form-input-error" >Required</div>
                                            } */}
                    </div>

                    <div className="form-group select-cat-wrap">
                      <Select
                        value={categoryToUpload}
                        onChange={saveUploadCat}
                        options={catListItems}
                        placeholder="Category"
                        className="select-wrap"
                      />
                      {/* <select name="" id="">
                                                <option value="">Choose a category</option>
                                                {
                                                    pageProps.getProductMetaDataRequest.request_data.response.categories.map((catItem: any, index: any) => {
                                                        return (
                                                            <option key={index}>{catItem.name}</option>
                                                        )
                                                    })
                                                }
                                            </select> */}
                      {/* {productCatError &&
                                                <div className="form-input-error">Required</div>
                                            } */}
                    </div>
                  </div>
                  <div className="form-group">
                    <ReactTags
                      delimiters={delimiters}
                      tags={uploadOtherNamesTags}
                      handleDelete={handleDelete}
                      handleAddition={handleAddition}
                      classNames={{
                        tagInput: "tagInputClass",
                        tagInputField: "input-wrap",
                      }}
                      placeholder="Other Names of this upload. e.g: Name1, Name2, Name3"
                    />
                    {/* <input placeholder="Other Names of this upload. e.g: Name1, Name2, Name3"
                                            onChange={(e: any) => {
                                                if (e.target.value.trim().length >= 1) {
                                                    setUploadProductOtherNames(e.target.value)
                                                }


                                            }}
                                            type="text"
                                            value={productUploadOtherNames}
                                            name="" id=""
                                            className="input-wrap" /> */}
                    <span className="info-txt">
                      **Type Other Name and press enter
                    </span>
                  </div>
                </div>
                {(productNameError || productCatError) && (
                  <div className="form-input-error text-center">
                    Provide product image name and category before upload
                  </div>
                )}
                <ImageUploadBox />

                {pageProps.updateProductImageRequest.request_status ===
                  "UPLOAD_PRODUCT_PICTURE_SUCCESS" && (
                    <>
                      {setImagesUploaded.map((eachImage: any, index: any) => (
                        <div className="progress-indicator" key={index}>
                          <div className="uploading">
                            <div className="file-progress-wrap">
                              <div className="filename">
                                {transformImageName(eachImage.url)}
                              </div>
                            </div>
                            <div className="status-icons">
                              <div
                                className="remove-now"
                                onClick={() => {
                                  removeImageFromUploads(eachImage);
                                }}
                              >
                                <img src={RemoveIcon} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
              </div>
              {/* <div className="progress-indicator">
                                <div className="uploading">
                                    <div className="file-progress-wrap">
                                        <div className="filename">Tungchivo-avatar.png</div>
                                    </div>
                                    <div className="status-icons">
                                        <div className="remove-now"><img src={RemoveIcon} alt="" /></div>

                                    </div>
                                </div>
                            </div> */}
              {/* <div className="progress-indicator">
                                <div className="uploading">
                                    <div className="file-progress-wrap">
                                        <div className="filename">Tungchivo-avatar.png</div>
                                        <div className="file-progress">
                                            <div className="percent-width"></div>
                                        </div>
                                        <div className="size-percent">
                                            <div className="sizetxt">428KB</div>
                                            <div className="percent-txt">70%</div>
                                        </div>
                                    </div>
                                    <div className="status-icons">
                                        <div><img src={DoneIcon} alt="" /></div>
                                        <div><img src={RemoveIcon} alt="" /></div>

                                    </div>
                                </div>
                                <div className="uploaded">
                                    <div className="filename-txt">Tungchivo-avatar.png</div>
                                    <div className="size-msg">
                                        428KB
                                        <img src={RemoveIcon} alt="" />
                                    </div>
                                </div>
                            </div> */}
            </Tab.Pane>
            <Tab.Pane eventKey="mami_gallery">
              <div className="search-gallery">
                <div className="each-filter for-search">
                  <input
                    type="text"
                    placeholder="Enter Product title or category"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                    }}
                    onBlur={(e) => {
                      saveSearchFilter(e.target.value.trim());
                    }}
                  />
                  <button>
                    <img src={SearchIco} alt="" />
                  </button>
                </div>
                {pageProps.getImageGalleryRequest?.galleryData &&
                  pageProps.getImageGalleryRequest?.galleryData.length >= 1 && (
                    <div>
                      <div className="gallery-head">
                        <h3>MamiMarket Gallery</h3>
                        <div className="gallery-txt">
                          Choose from thousands of stunning images..
                        </div>
                        {/* {
                                                pageProps.getImageGalleryRequest?.request_data?.response?.pageNumber
                                            }
                                            {
                                                pageProps.getImageGalleryRequest?.request_data?.response?.totalNumberOfPages
                                            } */}
                      </div>
                      <div className="filter-wrap">
                        <label htmlFor="">Filter by:</label>
                        <div className="filter-options">
                          <Select
                            value={categoryChosen}
                            onChange={saveChosenCat}
                            options={catListItems}
                            placeholder="Category"
                            className="select-wrap"
                            classNamePrefix="gallery-cats"
                          />
                        </div>
                      </div>
                      <div
                        id="scrollableDiv"
                        style={{ height: 300, overflow: "auto" }}
                      >
                        <InfiniteScroll
                          dataLength={
                            pageProps.getImageGalleryRequest?.request_data
                              ?.response?.totalNumberOfPages * sizeofFetch
                          }
                          // dataLength={pageProps.getImageGalleryRequest.request_data.response.totalNumberOfRecords}
                          next={() => {
                            let payload = `page=${pageProps.getImageGalleryRequest?.request_data
                              ?.response?.totalNumberOfPages + 1
                              }&size=${sizeofFetch}`;
                            if (categoryChosen?.label) {
                              payload = `${payload}&fileName=${categoryChosen?.label}`;
                            }
                            if (searchTerm) {
                              payload = `${payload}&fileName=${searchTerm}`;
                            }

                            getMoreImages({ pageProps, payload });
                          }}
                          // hasMore={true}
                          hasMore={
                            pageProps.getImageGalleryRequest?.request_data
                              ?.response?.pageNumber >
                            pageProps.getImageGalleryRequest?.request_data
                              ?.response?.totalNumberOfPages
                          }
                          loader={<LoadingItem />}
                          scrollableTarget="scrollableDiv"
                        >
                          {pageProps.getImageGalleryRequest?.galleryData.map(
                            (image: any, index: any) => (
                              // {pageProps.getImageGalleryRequest?.request_data?.response?.results.map((image: any, index: any) => (
                              <div
                                className={`each-image each-image-xy-${index} `}
                                key={index}
                                // style={{
                                //     backgroundImage: `url(${image.imageUrl})`
                                // }}
                                onClick={(e) => {
                                  imagesChosen = [...setImagesUploaded];

                                  if (
                                    !imagesChosen.find(
                                      (eachImage: any) =>
                                        eachImage.url === image.imageUrl,
                                    )
                                  ) {
                                    imagesChosen.push({
                                      url: image.imageUrl,
                                      index,
                                      othernames: image?.otherNames
                                        ? [...image?.otherNames]
                                        : [],
                                    });
                                    setImagesUploadedStore(imagesChosen);
                                  } else {
                                    removeImageFromUploads(image.imageUrl);
                                    // imagesChosen = imagesChosen.filter((itemData: any) => {
                                    //     return itemData.url !== image.imageUrl;
                                    // });
                                  }

                                  document
                                    .querySelector(`.each-image-xy-${index}`)
                                    ?.classList?.toggle("chosen-image");
                                }}
                              >
                                <img
                                  src={image.imageUrl}
                                  alt=""
                                  className="gallery-img"
                                />
                              </div>
                            ),
                          )}
                        </InfiniteScroll>
                      </div>
                    </div>
                  )}
                {pageProps.getImageGalleryRequest.request_status ===
                  "GET_IMAGE_GALLERY_PENDING" && <LoadingItem />}
                {pageProps.getImageGalleryRequest.request_status ===
                  "GET_IMAGE_GALLERY_FAILURE" && (
                    <AlertMsg
                      type="error"
                      message={
                        pageProps.getImageGalleryRequest?.request_data.error
                      }
                    />
                  )}
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Modal.Body>
      {(pageProps.getImageGalleryRequest.request_status ===
        "GET_IMAGE_GALLERY_SUCCESS" ||
        pageProps.getImageGalleryRequest.request_status ===
        "GET_IMAGE_GALLERY_NEWBATCH") && (
          <Modal.Footer>
            <button
              onClick={() => {
                // if (imagesChosen.length >= 1) {
                //     // setSelectedImagesStore(imagesChosen)
                //     hideProductImgModal()
                // }
                uploadImagesData.length = 0;

                uploadImagesData.push(...setImagesUploaded);
                hideProductImgModal();
              }}
            >
              {" "}
              Add to Product
            </button>
          </Modal.Footer>
        )}
    </Modal>
  );
};

export const EditProductForm = ({ pageProps, setSuppressRedirect, returnTo }: any) => {
  const { showToast } = useToast();
  const modules = {
    toolbar: [
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["image", "link"],
    ],
  };

  const formats = [
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "align",
    "list",
    "bullet",
    "image",
    "link",
  ];

  let productInfo = pageProps.getAProductRequest.request_data.response;
  const normalizedProductForm = normalizeProductResponseToForm(productInfo);
  const [showImagesModal, setShowImagesModal] = useState(false);
  const [isCatError, setShowCatError] = useState(false);
  const [isImagesError, setNoImages] = useState(false);
  const [newPhotoStatus, setNewPhotoStatus] = useState<any>();
  const [initialValues, setInitialValues] = useState<any>();

  const [allCatsList, setAllCatsList] = useState<any[]>([]);
  const [allCatsSelected, setAllCatsSelected] = useState<any[]>([]);
  const [isDiscountMore, setIsDiscountMore] = useState(false);
  const [isTaxableOption, setIsTaxable] = useState(
    normalizedProductForm.isTaxable,
  );

  const [startDate, onStartChange] = useState<any>(
    normalizedProductForm.startDate,
  );
  const [endDate, onEndChange] = useState<any>(normalizedProductForm.endDate);

  const [selecteCatsStore, setSelecteCatsStore] = useState<any[]>([
    ...productInfo.categories,
  ]);
  const [updatedCatList, setUpdatedCatList] = useState<any>([
    ...productInfo.categories,
  ]);

  const [selectedImagesStore, setSelectedImagesStore] = useState<any>(
    normalizedProductForm.selectedImages,
  );
  const [catListItems, setCatListItems] = useState<any>();
  const { getImageGalleryReducer } = useSelector(
    (state: any) => state.allProductReducers,
  );
  const { productId } = useParams();

  // New product features state
  const [wholesaleProduct, setWholesaleProduct] = useState(
    normalizedProductForm.wholesaleProduct,
  );
  const [minimumOrderQuantity, setMinimumOrderQuantity] = useState(
    normalizedProductForm.minimumOrderQuantity,
  );
  const [availability, setAvailability] = useState(
    normalizedProductForm.availability,
  );
  const [addVariant, setAddVariant] = useState(normalizedProductForm.addVariant);
  const [attributes, setAttributes] = useState<EditableProductAttribute[]>(
    normalizedProductForm.attributes,
  );
  const [variants, setVariants] = useState<Variant[]>(
    normalizedProductForm.variants,
  );
  const [eligibleForReturn, setEligibleForReturn] = useState(
    normalizedProductForm.eligibleForReturn,
  );
  const [eligibleForReturnOption, setEligibleForReturnOption] = useState(
    normalizedProductForm.eligibleForReturnOption,
  );
  const [showAddEditVariantPopup, setShowAddEditVariantPopup] = useState(false);
  const [editingVariantIndex, setEditingVariantIndex] = useState<number | null>(
    null,
  );
  const [variantToEdit, setVariantToEdit] = useState<any>(null);
  const [productNameForVariants, setProductNameForVariants] = useState(
    normalizedProductForm.initialValues.productName,
  );

  const [orderCutOffDate, setOrderCutOffDate] = useState<any>(
    normalizedProductForm.wholesaleOrderCutOffDate,
  );
  const [expectedAvailabilityDate, setExpectedAvailabilityDate] = useState<any>(
    normalizedProductForm.wholesaleExpectedDeliveryDate,
  );
  const [showOrderCutoffTooltip, setShowOrderCutoffTooltip] = useState(false);
  const [showExpectedAvailabilityTooltip, setShowExpectedAvailabilityTooltip] = useState(false);

  const [schemaErrors, setSchemaErrors] = useState<string[]>([])
  const [isChainedVariantUpdateRunning, setIsChainedVariantUpdateRunning] =
    useState(false);

  const [shippingMethod, setShippingMethod] = useState("paid");

  // let categoriesChosen: any = [...productInfo.categories];
  let imagesChosen: any = [],
    categoriesList = [...productInfo.categories];

  const checkForCategory = (cat: any) => {
    if (categoriesList.find((eachCat: any) => eachCat === cat)) {
      return true;
    }
    return false;
  };
  // useEffect(() => {
  //     imagesChosen.length = 0;
  //     productInfo.urls.map((eachImg: any, index: any) => {

  //         imagesChosen.push({
  //             index,
  //             url: eachImg
  //         })
  //         if (index === productInfo?.urls.length - 1) {
  //             setSelectedImagesStore(imagesChosen)
  //         }
  //     })

  // }, [])

  useEffect(() => {
    let catsData: any[] = productInfo.categories;
    let allCatAvailable =
      pageProps.getProductMetaDataRequest.request_data.response.categories;

    let catFormated: any[] = normalizedProductForm.categories;
    let catAvailableFormated: any[] = allCatAvailable.map((each: any) => {
      return { label: each?.name, value: each?.name };
    });

    setAllCatsSelected(catFormated);

    setAllCatsList(catAvailableFormated);
    setInitialValues(normalizedProductForm.initialValues);
    onStartChange(normalizedProductForm.startDate);
    onEndChange(normalizedProductForm.endDate);
    setVariants(normalizedProductForm.variants);
    setAddVariant(normalizedProductForm.addVariant);
    setEligibleForReturn(normalizedProductForm.eligibleForReturn);
    setEligibleForReturnOption(normalizedProductForm.eligibleForReturnOption);
    setSelectedImagesStore(normalizedProductForm.selectedImages);
    setIsTaxable(normalizedProductForm.isTaxable);
    setProductNameForVariants(normalizedProductForm.initialValues.productName);
    setAttributes(normalizedProductForm.attributes);

    // Initialize wholesale fields from normalizedProductForm (reads wholesalePrice.* flat API keys)
    if (productInfo.hasWholesaleOffer) {
      setWholesaleProduct(true);
    }
    if (productInfo.wholesaleMinimumOrderQuantity != null) {
      setMinimumOrderQuantity(productInfo.wholesaleMinimumOrderQuantity.toString());
    }
    if (productInfo.wholesaleAvailabilityMode != null) {
      setAvailability(productInfo.wholesaleAvailabilityMode.toString());
    }
    if (normalizedProductForm.wholesaleOrderCutOffDate) {
      setOrderCutOffDate(normalizedProductForm.wholesaleOrderCutOffDate);
    }
    if (normalizedProductForm.wholesaleExpectedDeliveryDate) {
      setExpectedAvailabilityDate(normalizedProductForm.wholesaleExpectedDeliveryDate);
    }
  }, []);

  const openVariantModal = (nextProductName: string) => {
    if (!nextProductName.replace(/\s+/g, " ").trim()) {
      showToast({
        title: "Fill a product name",
        description: "Add a product name before managing variants.",
        type: "error",
      });
      return;
    }

    setShowAddEditVariantPopup(true);
  };

  useEffect(() => {
    if (newPhotoStatus === "yes" && uploadImagesData.length >= 1) {
      setSelectedImagesStore(uploadImagesData);
    } else {
      setSelectedImagesStore(selectedImagesStore);
    }
  }, [newPhotoStatus]);

  const hideProductImgModal = () => {
    setNewPhotoStatus("yes");
    setShowImagesModal(false);
  };

  const clearProductDiscountState = (setFieldValue: any) => {
    setFieldValue("addDiscount", false);
    setFieldValue("productDiscountPercent", "");
    setFieldValue("productDiscountPrice", "");
    setFieldValue("productDiscountStart", "");
    setFieldValue("productDiscountEnd", "");
    onStartChange(undefined);
    onEndChange(undefined);
  };

  // const removeProductImage = (index: any) => {
  //     let imagesBatch = selectedImagesStore;
  //     imagesBatch = imagesBatch.filter((itemData: any) => {
  //         return itemData.index !== index;
  //     });
  //     setSelectedImagesStore(imagesBatch)
  // }

  const removeProductImage = (url: any) => {
    let imagesBatch = selectedImagesStore;

    imagesBatch = imagesBatch.filter((itemData: any) => {
      return itemData.url !== url;
    });
    uploadImagesData.length = 1;
    uploadImagesData.push(...imagesBatch);

    setSelectedImagesStore(imagesBatch);
  };

  let detailsValidationSchema = Yup.object().shape({
    productName: Yup.string().required("Required"),
    productPrice: Yup.string().test(
      "product-price-required",
      "Required",
      (value, context) => {
        if (context.parent?.addVariant === true) {
          return true;
        }
        return !!value;
      },
    ),
    productSize: Yup.string().required("Required"),
    productQty: Yup.string().required("Required"),
    productUnit: Yup.string().required("Required"),
    // productStatus: Yup.string()
    //     .required("Required"),
    productTags: Yup.string(),
    addDiscount: Yup.boolean(),
    productDiscountPercent: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    productDiscountPrice: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    productDiscountStart: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    productDiscountEnd: Yup.string().when("addDiscount", {
      is: (addDiscount: boolean) => addDiscount === true,
      then: Yup.string().required("Required"),
    }),
    productDesc: Yup.string().required("Required"),
    orderCutOffDate: Yup.string().when(["wholesaleProduct", "availability"], {
      is: (wholesaleProduct: boolean, availability: string) =>
        wholesaleProduct === true && availability === "2",
      then: Yup.string().required("Order cut-off date is required"),
    }),
    expectedAvailabilityDate: Yup.string().when(["wholesaleProduct", "availability"], {
      is: (wholesaleProduct: boolean, availability: string) =>
        wholesaleProduct === true && availability === "2",
      then: Yup.string().required("Expected availability date is required"),
    }),
  });

  // let existingDiff, exisitingPerCentOffer;
  //     if (productInfo?.discountPrice) {
  //         existingDiff = parseFloat(productInfo?.price?.amount) - productInfo?.discountPrice?.amount;
  //             exisitingPerCentOffer = Math.round((existingDiff / parseFloat(productInfo?.price?.amount)) * 100);
  //     }

  // let initialValues: any = {
  //     productName: productInfo.name,
  //     productPrice: productInfo?.price?.amount.toString(),
  //     // productPrice: "",
  //     productSize: productInfo.sizePerUnit.toString(),
  //     productQty: productInfo.availableQuantity.toString(),
  //     productUnit: productInfo.unitOfMeasurementId >= 1 ? productInfo.unitOfMeasurementId.toString() : "",
  //     // productStatus: "",
  //     productDesc: productInfo.description,

  //     productDiscountPercent: !productInfo?.discountPrice ? "" : exisitingPerCentOffer,
  //     productDiscountPrice: !productInfo?.discountPrice ? "" : productInfo?.discountPrice?.amount.toString(),
  //     productDiscountStart: startDate ? startDate.toISOString(): "",
  //     productDiscountEnd: endDate ? endDate.toISOString(): "",
  //     // startDate: !productInfo?.discountPrice ? "" : productInfo?.discountPrice?.startDate,
  //     // endDate: "",

  //     addDiscount: !productInfo?.discountPrice ? false : true,
  // }

  // console.log("updated CatList", updatedCatList)
  // console.log("selected ImagesStore", selectedImagesStore)

  return (
    <div>
      {/* {showImagesModal && <ProductImagePop />} */}

      {showImagesModal && (
        <ImageDrawer
          pageProps={pageProps}
          showDrawer={showImagesModal}
          catListItems={catListItems}
          onClose={hideProductImgModal}
          selectedImages={selectedImagesStore}
          title="Add product image"
          applyButtonLabel="Add to Product"
          onApply={(images: any[]) => {
            uploadImagesData.length = 0;
            uploadImagesData.push(...images);
            setSelectedImagesStore(images);
            setShowImagesModal(false);
          }}
        />
      )}

      {showAddEditVariantPopup && (
        <ProductVarianceModal
          show={showAddEditVariantPopup}
          initialEditVariant={variantToEdit}
          editIndex={editingVariantIndex}
          onClose={() => {
            setShowAddEditVariantPopup(false);
            setEditingVariantIndex(null);
            setVariantToEdit(null);
          }}
          attributes={attributes}
          setAttributes={setAttributes}
          variants={variants}
          setVariants={setVariants}
          pageProps={pageProps}
          sizeOfFetch={sizeofFetch}
          productName={productNameForVariants}
        />
      )}

      {/* {pageProps.getProductMetaDataRequest.request_status === "GET_PRODUCT_META_SUCCESS" && */}
      <div className="product-form">
        {initialValues && (
          <Formik
            initialValues={initialValues}
            validationSchema={detailsValidationSchema}
            onSubmit={async (values: any, actions) => {
              const errors: string[] = [];
              let loggedAccountInfo: any =
                localStorage.getItem("mamiVendorXAuth") || "{}";
              loggedAccountInfo = JSON.parse(loggedAccountInfo);

              let urlsList = selectedImagesStore.map((img: any) => img.url);

              // if (updatedCatList.length >= 1) {
              if (allCatsSelected.length >= 1) {
                setShowCatError(false);
              } else {
                errors.push("You are required to select a category");
                setShowCatError(true);
              }
              if (urlsList.length >= 1) {
                setNoImages(false);
              } else {
                errors.push("You are required to select an image");
                setNoImages(true);
              }

              try {
                await detailsValidationSchema.validate(values, { abortEarly: false });
              } catch (err: any) {
                err.inner.forEach((e: any) => errors.push(e.message));
              }

              let chosenCats = allCatsSelected.map((cat: any) => cat.value);
              let formattedStart: any, formattedEnd: any;

              if (startDate && endDate) {
                formattedStart = new Date(startDate.toISOString());
                formattedStart.setDate(formattedStart.getDate());
                formattedStart = formattedStart.toISOString();

                formattedEnd = new Date(endDate.toISOString());
                formattedEnd.setDate(formattedEnd.getDate());
                formattedEnd = formattedEnd.toISOString();
              }

                              const hasVariantModeEnabled = addVariant;
                              const variantSelectionError =
                                addVariant && variants.length === 0
                                  ? "Add at least one variant before saving this product"
                                  : null;

                              const productDraft = {
                productId,
                storeId: loggedAccountInfo.selectedStore.id,
                name: values.productName,
                categories: chosenCats,
                description: values.productDesc,
                availableQuantity: parseInt(values.productQty),
                unitOfMeasureId: parseInt(values.productUnit),
                sizePerUnit: parseFloat(values.productSize.replace(/,/g, "")),
                priceAmount: parseMoneyInput(values.productPrice) ?? 0,
                isTaxable: isTaxableOption,
                wholesaleProduct,
                minimumOrderQuantity:
                  wholesaleProduct && minimumOrderQuantity
                    ? parseInt(minimumOrderQuantity)
                    : undefined,
                availability: availability !== "0" ? availability : undefined,
                orderCutOffDate:
                  wholesaleProduct && availability === "2" && orderCutOffDate
                    ? orderCutOffDate.toISOString()
                    : undefined,
                expectedFulfillmentDate:
                  wholesaleProduct && availability === "2" && expectedAvailabilityDate
                    ? expectedAvailabilityDate.toISOString()
                    : undefined,
                isReturnable: eligibleForReturn,
                returnPeriod:
                  eligibleForReturn && eligibleForReturnOption !== "0"
                    ? eligibleForReturnOption
                    : undefined,
                selectedImages: selectedImagesStore,
                existingOtherNames: productInfo?.otherNames,
                attributes: hasVariantModeEnabled ? attributes : [],
                variants: hasVariantModeEnabled ? variants : [],
                hasVariantsEnabled: hasVariantModeEnabled,
                originalProductType: productInfo?.productType,
                discountPriceAmount:
                  !hasVariantModeEnabled && values.addDiscount
                    ? parseMoneyInput(values.productDiscountPrice)
                    : undefined,
                discountStartDate: formattedStart,
                discountEndDate: formattedEnd,
              };
              const submissionErrors = [
                ...errors,
                ...(variantSelectionError ? [variantSelectionError] : []),
                ...getProductSubmissionErrors(productDraft),
              ];

              if (submissionErrors.length > 0) {
                setSchemaErrors(Array.from(new Set(submissionErrors)));
                return;
              }

              setSchemaErrors([]);

              const payload = buildProductPayload(productDraft);

              editProduct({ pageProps, payload });
            }}
          >
            {(props: FormikProps<any>) => {
              const {
                values,
                touched,
                errors,
                setFieldTouched,
                setFieldError,
                handleChange,
                setFieldValue,
              } = props;
              const hasVariantModeEnabled = addVariant;
              return (
                <Form>
                  <div className="form-wrap">
                    <div className="right-product-form">
                      <div className="product-images-container">
                        <div
                          className={
                            selectedImagesStore.length >= 1
                              ? "image-control"
                              : "image-control full"
                          }
                        >
                          <div className="images-label">Product image</div>
                          <div
                            className="product-images"
                            onClick={() => {
                              let allCatData: any = [];
                              pageProps.getProductMetaDataRequest.request_data.response.categories.forEach(
                                (eachCat: any) => {
                                  allCatData.push({
                                    value: eachCat.name,
                                    label: eachCat.name,
                                  });
                                },
                              );
                              imagesChosen.length = 0;

                              setCatListItems(allCatData);
                              let payload = `page=1&size=${sizeofFetch}`;
                              getImagesGallery({ pageProps, payload });
                              setNewPhotoStatus("no");
                              setShowImagesModal(true);
                            }}
                          >
                            <div className="upload-wrap-content">
                              <img src={AddImg} alt="" />
                              <div className="upload-txt">
                                Check <span>MamiMarkets Gallery</span> or{" "}
                                <span>Upload from your device</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        {
                          // (!showImagesModal && selectedImagesStore.length >= 1) &&
                          selectedImagesStore.length >= 1 && (
                            <div className="all-images-chosen">
                              {selectedImagesStore.map(
                                (eachImage: any, index: any) => {
                                  return (
                                    <div
                                      className="product-image-wrap"
                                      key={index}
                                    >
                                      <div className="image-actions">
                                        <div className="select-cover">
                                          <input
                                            type="radio"
                                            name="cover-image-select"
                                          />
                                        </div>
                                        <div
                                          className="deleteicon"
                                          onClick={() =>
                                            removeProductImage(eachImage.url)
                                          }
                                        >
                                          <img
                                            src={TrashIcon}
                                            alt=""
                                            className=""
                                          />
                                        </div>
                                      </div>
                                      <div
                                        className="product-image-item"
                                        key={index}
                                      // style={{
                                      //     backgroundImage: `url(${eachImage.url})`
                                      // }}
                                      >
                                        <img src={eachImage.url} alt="" />
                                      </div>
                                    </div>
                                  );
                                },
                              )}
                            </div>
                          )
                        }
                      </div>
                      <div className="uploads-msg">
                        Ensure you use high-quality images that clearly showcase
                        the product. Also note that pictures must be in 450 x
                        450 dimension. Max file size of 5mb.
                      </div>
                      <div className="form-group thin-bordered-box">
                        <div className="tax-label">
                          Is this product taxable? <span>Learn more</span>{" "}
                        </div>
                        <div className="all_options">
                          <div className="an_option">
                            <span
                              className={` custom_radio  ${isTaxableOption ? "selected_option" : ""
                                }`}
                            >
                              <input
                                onChange={(e) => setIsTaxable(true)}
                                name="check_taxable"
                                type="radio"
                                id="isTaxable"
                                value="isTaxable"
                              />
                            </span>
                            <label htmlFor="isTaxable">
                              <span>Yes</span>
                            </label>
                          </div>
                          <div className="an_option">
                            <span
                              className={`custom_radio ${!isTaxableOption ? "selected_option" : ""
                                }`}
                            >
                              <input
                                onChange={(e) => setIsTaxable(false)}
                                name="check_taxable"
                                type="radio"
                                id="notTaxable"
                                value="notTaxable"
                              />
                            </span>
                            <label htmlFor="notTaxable">
                              <span>No</span>
                            </label>
                          </div>
                        </div>
                        <br />
                        <div
                          className={
                            errors.productTags && touched.productTags
                              ? "invalid-input-wrap"
                              : ""
                          }
                        >
                          <label
                            htmlFor="productTags"
                            className="tax-label"
                          >
                            Product tags (optional)
                            <ErrorMessage
                              name="productTags"
                              className="form-input-error"
                              component="span"
                            />
                          </label>
                          <Field
                            value={values.productTags}
                            name="productTags"
                            id="productTags"
                            type="text"
                            autoComplete="off"
                            onChange={handleChange}
                            className={`input-wrap inapp-input ${errors.productTags && touched.productTags
                              ? "is-invalid-input "
                              : !errors.productTags &&
                                values.productTags !== ""
                                ? "valid-input"
                                : ""
                              }`}
                          ></Field>
                          <div className="tax-label">
                            Suggested: <span>perishable</span>,{" "}
                            <span>nutritious</span>, <span>delicious</span>
                          </div>
                        </div>
                      </div>
                      <br/>
                      <div className="add-discount-wrap">
                        <Field
                          onChange={handleChange}
                          type="checkbox"
                          name="addDiscount"
                          id="addDiscount"
                          disabled={hasVariantModeEnabled}
                        />
                        <label htmlFor="addDiscount">Add a discount</label>
                      </div>
                      {values.addDiscount === true &&
                        !hasVariantModeEnabled && (
                        <div className="discount-wrap">
                          <div className="two-sided">
                            <div className="form-group">
                              <div
                                className={
                                  errors.productDiscountPercent &&
                                    touched.productDiscountPercent
                                    ? "invalid-input-wrap "
                                    : ""
                                }
                              >
                                <label htmlFor="productDiscountPercent">
                                  Discount %
                                  {values.productPrice && (
                                    <ErrorMessage
                                      name="productDiscountPercent"
                                      className="form-input-error"
                                      component="span"
                                    />
                                  )}
                                  {!values.productPrice && (
                                    <span className="price-info-txt">
                                      (Enter original price)
                                    </span>
                                  )}
                                </label>

                                <Field
                                  value={allowNumbersOnly(
                                    values.productDiscountPercent,
                                    3,
                                  )}
                                  name="productDiscountPercent"
                                  type="text"
                                  autoComplete="off"
                                  placeholder="Discount %"
                                  disabled={
                                    !values.productPrice || hasVariantModeEnabled
                                  }
                                  // onChange={handleChange}
                                  onChange={(e: any) => {
                                    let valueSet: any = numberWithCommas(
                                      e.target.value,
                                    );

                                    if (
                                      parseFloat(valueSet) <= 100 ||
                                      e.target.value === ""
                                    ) {
                                      setFieldTouched(
                                        "productDiscountPercent",
                                        true,
                                        true,
                                      );
                                      setFieldValue(
                                        "productDiscountPercent",
                                        valueSet,
                                      );

                                      setFieldValue(
                                        "productDiscountPrice",
                                        calculateDiscountedPrice(
                                          values.productPrice,
                                          valueSet,
                                        ),
                                      );
                                    }
                                  }}
                                  className={`input-wrap inapp-input ${errors.productDiscountPercent &&
                                    touched.productDiscountPercent
                                    ? "is-invalid-input "
                                    : !errors.productDiscountPercent &&
                                      values.productDiscountPercent !== ""
                                      ? "valid-input"
                                      : ""
                                    }`}
                                ></Field>
                              </div>
                            </div>
                            <div className="form-group">
                              <div
                                className={
                                  (errors.productDiscountPrice &&
                                    touched.productDiscountPrice) ||
                                    isDiscountMore
                                    ? "invalid-input-wrap "
                                    : ""
                                }
                              >
                                <label htmlFor="productDiscountPrice">
                                  New price
                                  {errors.productDiscountPrice &&
                                    touched.productDiscountPrice && (
                                      <ErrorMessage
                                        name="productDiscountPrice"
                                        className="form-input-error"
                                        component="span"
                                      />
                                    )}
                                  {!values.productPrice && (
                                    <span className="price-info-txt">
                                      (Enter original price)
                                    </span>
                                  )}
                                </label>

                                <div className="price-wrap">
                                  <span className="currency-pre">$</span>
                                  <Field
                                    value={values.productDiscountPrice}
                                    name="productDiscountPrice"
                                    type="text"
                                    autoComplete="off"
                                    // onChange={handleChange}
                                    disabled={
                                      !values.productPrice || hasVariantModeEnabled
                                    }
                                    onChange={(e: any) => {
                                      let valueSet: any = numberWithCommas(
                                        e.target.value,
                                      );
                                      setFieldTouched(
                                        "productDiscountPrice",
                                        true,
                                        true,
                                      );

                                      setFieldValue(
                                        "productDiscountPrice",
                                        valueSet,
                                      );

                                      if (
                                        (parseMoneyInput(valueSet) ?? 0) >=
                                        (parseMoneyInput(values.productPrice) ?? 0)
                                      ) {
                                        setIsDiscountMore(true);
                                        setFieldValue(
                                          "productDiscountPercent",
                                          "",
                                        );
                                      } else {
                                        setIsDiscountMore(false);
                                        setFieldValue(
                                          "productDiscountPercent",
                                          calculateDiscountPercent(
                                            values.productPrice,
                                            valueSet,
                                          ),
                                        );
                                      }
                                      // setFieldError
                                    }}
                                    className={`input-wrap inapp-input ${(errors.productDiscountPrice &&
                                      touched.productDiscountPrice) ||
                                      isDiscountMore
                                      ? "is-invalid-input "
                                      : !errors.productDiscountPrice &&
                                        values.productDiscountPrice !== ""
                                        ? "valid-input"
                                        : ""
                                      }`}
                                  ></Field>
                                </div>
                                {isDiscountMore && (
                                  <div className="form-input-error">
                                    *Discount must be less than price
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="two-sided">
                            <div className="form-group">
                              <div
                                className={
                                  errors.productDiscountStart &&
                                    touched.productDiscountStart
                                    ? "invalid-input-wrap "
                                    : ""
                                }
                              >
                                <label htmlFor="productDiscountStart">
                                  Start date
                                  <ErrorMessage
                                    name="productDiscountStart"
                                    className="form-input-error"
                                    component="span"
                                  />
                                </label>

                                <DatePicker
                                  selected={startDate}
                                  onChange={(date: any) => {
                                    onStartChange(date);
                                    setFieldTouched(
                                      "productDiscountStart",
                                      true,
                                    );
                                    setFieldValue(
                                      "productDiscountStart",
                                      date ? date.toISOString() : "",
                                    );
                                  }}
                                  minDate={new Date()}
                                  name="productDiscountStart"
                                  // maxDate={new Date()}
                                  placeholderText="Select start date"
                                />
                              </div>
                            </div>
                            <div className="form-group">
                              <div
                                className={
                                  errors.productDiscountEnd &&
                                    touched.productDiscountEnd
                                    ? "invalid-input-wrap "
                                    : ""
                                }
                              >
                                <label htmlFor="productDiscountEnd">
                                  End date
                                  <ErrorMessage
                                    name="productDiscountEnd"
                                    className="form-input-error"
                                    component="span"
                                  />
                                </label>
                                <DatePicker
                                  selected={endDate}
                                  onChange={(date: any) => {
                                    onEndChange(date);
                                    setFieldTouched("productDiscountEnd", true);
                                    setFieldValue(
                                      "productDiscountEnd",
                                      date ? date.toISOString() : "",
                                    );
                                  }}
                                  name="productDiscountEnd"
                                  minDate={new Date()}
                                  // maxDate={new Date()}
                                  placeholderText="Select end date"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {pageProps?.updateStoreProductRequest?.request_status &&
                        pageProps.updateStoreProductRequest.request_status ===
                        "UPDATE_PRODUCT_FAILURE" && (
                          <AlertMsg
                            type="error"
                            message={getRequestErrorMessage(
                              pageProps.updateStoreProductRequest,
                            )}
                          />
                        )}
                      {isCatError && (
                        <AlertMsg type="error" message="No Category Selected" />
                      )}
                      {isImagesError && (
                        <AlertMsg type="error" message="No Images Selected" />
                      )}

                      {schemaErrors.length > 0 && (
                        <AlertMsg
                          type="error"
                          message={schemaErrors.join(", ")}
                        />
                      )}


                      <div className="product-cta">
                        <button
                          disabled={
                            pageProps.updateStoreProductRequest
                              ?.is_request_processing ||
                            isChainedVariantUpdateRunning
                            // ||
                            // allCatsSelected.length < 1
                            // updatedCatList.length < 1
                          }
                          className="btn"
                        // className={
                        //   selectedImagesStore.length >= 1
                        //     ? "btn"
                        //     : "btn btn-disabled"
                        // }
                        >
                          {pageProps.updateStoreProductRequest
                            .is_request_processing ||
                            isChainedVariantUpdateRunning
                            ? "Please wait..."
                            : "Update Product"}
                        </button>
                      </div>
                    </div>
                    <div className="product-info">
                      <div className="form-group thin-bordered-box">
                        <div
                          className={
                            errors.productName && touched.productName
                              ? "invalid-input-wrap"
                              : ""
                          }
                        >
                          <label htmlFor="productName">
                            Product name
                            <ErrorMessage
                              name="productName"
                              className="form-input-error"
                              component="span"
                            />
                          </label>
                          <Field
                            value={values.productName}
                            name="productName"
                            id="productName"
                            autoComplete="off"
                            type="text"
                            placeholder="Enter product name here"
                            onChange={(event: any) => {
                              handleChange(event);
                              setProductNameForVariants(event.target.value);
                            }}
                            className={`input-wrap inapp-input ${errors.productName && touched.productName
                              ? "is-invalid-input "
                              : !errors.productName &&
                                values.productName !== ""
                                ? "valid-input"
                                : ""
                              }`}
                          ></Field>
                          <small className="help-text">
                            Maximum of 50 characters
                          </small>
                        </div>
                        <br />
                        <div className="">
                          <label htmlFor="productName">Category</label>
                          <MultiSelect
                            options={allCatsList}
                            value={allCatsSelected}
                            onChange={setAllCatsSelected}
                            labelledBy="Select"
                            hasSelectAll={false}
                            className="cat-select-wrap"
                          />
                        </div>

                        <div className="two-sided for_pricing">
                          <div className="form-group pricing_wrap">
                            <div
                              className={
                                errors.productPrice && touched.productPrice
                                  ? "invalid-input-wrap "
                                  : ""
                              }
                            >
                              <label htmlFor="productPrice">
                                {wholesaleProduct ? "Wholesale Price" : "Price"}
                                <ErrorMessage
                                  name="productPrice"
                                  className="form-input-error"
                                  component="span"
                                />
                              </label>

                              <div className="price-wrap">
                                <span className="currency-pre">$</span>
                                <Field
                                  value={numberWithCommas(values.productPrice)}
                                  name="productPrice"
                                  type="text"
                                  placeholder=" Price"
                                  autoComplete="off"
                                  disabled={hasVariantModeEnabled}
                                  onChange={(e: any) => {
                                    let valueSet: any = numberWithCommas(
                                      e.target.value,
                                    );
                                    setFieldTouched("productPrice", true, true);

                                    setFieldValue("productPrice", valueSet);
                                    if (!e.target.value) {
                                      setFieldValue("productDiscountPercent", "");
                                      setFieldValue("productDiscountPrice", "");
                                    } else {
                                      if (values.productDiscountPercent) {
                                        setFieldValue(
                                          "productDiscountPrice",
                                          calculateDiscountedPrice(
                                            valueSet,
                                            values.productDiscountPercent,
                                          ),
                                        );
                                      }
                                    }
                                  }}
                                  className={`input-wrap inapp-input ${hasVariantModeEnabled
                                    ? "disabled-price-input "
                                    : ""
                                    }${errors.productPrice &&
                                    touched.productPrice
                                    ? "is-invalid-input "
                                    : !errors.productPrice &&
                                      values.productPrice !== ""
                                      ? "valid-input"
                                      : ""
                                    }`}
                                ></Field>
                              </div>
                            </div>
                          </div>
                          <div className="form-group qty_only_wrap">
                            <label htmlFor="productSize">
                              Size
                              <ErrorMessage
                                name="productSize"
                                className="form-input-error"
                                component="span"
                              />
                            </label>
                            <div
                              className={
                                (errors.productSize && touched.productSize) ||
                                  errors.productUnit
                                  ? "invalid-input qty-input"
                                  : "qty-input"
                              }
                            >
                              <div className="input-item">
                                <Field
                                  value={numberWithCommas(values.productSize)}
                                  name="productSize"
                                  type="text"
                                  autoComplete="off"
                                  placeholder="Size"
                                  onChange={handleChange}
                                  className={`${errors.productSize &&
                                    touched.productSize
                                    ? "is-invalid-input "
                                    : !errors.productSize &&
                                      values.productSize !== ""
                                      ? "valid-input"
                                      : ""
                                    }`}
                                ></Field>
                              </div>
                              <Field
                                value={values.productUnit}
                                name="productUnit"
                                as="select"
                                autoComplete="off"
                                onChange={handleChange}
                                placeholder=""
                                className={`${errors.productUnit && touched.productUnit
                                  ? "is-invalid-input"
                                  : !errors.productUnit &&
                                    values.productUnit !== ""
                                    ? "valid-input"
                                    : ""
                                  }`}
                              >
                                <option value="">size</option>
                                {pageProps.getProductMetaDataRequest.request_data.response.units.map(
                                  (eachUnit: any, index: any) => {
                                    return (
                                      <option
                                        key={index}
                                        value={eachUnit.id}
                                      >
                                        {eachUnit.unit}
                                      </option>
                                    );
                                  },
                                )}
                              </Field>
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="productQty">
                            Quantity Available
                            <ErrorMessage
                              name="productQty"
                              className="form-input-error"
                              component="span"
                            />
                          </label>
                          <div
                            className={
                              errors.productQty && touched.productQty
                                ? "invalid-input-wrap"
                                : ""
                            }
                          >
                            <Field
                              value={allowNumbersOnly(values.productQty)}
                              name="productQty"
                              type="text"
                              autoComplete="off"
                              placeholder="Enter Quantity"
                              onChange={handleChange}
                              className={`input-wrap inapp-input ${errors.productQty && touched.productQty
                                ? "is-invalid-input "
                                : !errors.productQty &&
                                  values.productQty == ""
                                  ? "valid-input"
                                  : ""
                                }`}
                            ></Field>
                          </div>
                        </div>

                        <div className="form-group">
                          <div>
                            <label htmlFor="productDesc">
                              Description
                              <ErrorMessage
                                name="productDesc"
                                className="form-input-error"
                                component="span"
                              />
                            </label>
                            <Field name="productDesc">
                              {({ field, form }: any) => (
                                <ReactQuill
                                  value={field.value}
                                  onChange={(val) =>
                                    form.setFieldValue(field.name, val)
                                  }
                                  onBlur={(_, __, quill) => {
                                    const plainText = quill.getText().trim();
                                    if (plainText.length === 0)
                                      form.setFieldValue(field.name, "");
                                    form.setFieldTouched(field.name, true);
                                  }}
                                  modules={modules}
                                  formats={formats}
                                  className={`custom-quill ${form.errors.productDesc &&
                                    form.touched.productDesc
                                    ? "is-invalid-input"
                                    : !form.errors.productDesc &&
                                      field.value
                                      ? "valid-input"
                                      : ""
                                    }`}
                                />
                              )}
                            </Field>
                            <small className="help-text">
                              Maximum of 500 characters
                            </small>
                          </div>
                        </div>
                      </div>
                      {/* Wholesale & Availability */}
                      <div className="form-group thin-bordered-box">
                        <div className="wholesale-available-product-box">
                          <div className="whosale-product-box">
                            <div className="checkbox-radio-wrap">
                              <label>
                                <input
                                  type="checkbox"
                                  checked={wholesaleProduct}
                                  onChange={(e) =>
                                    setWholesaleProduct(e.target.checked)
                                  }
                                  id="wholesaleProduct"
                                />
                                This is a wholesale product
                              </label>
                            </div>

                            {wholesaleProduct && (
                              <div className="min-order-qty-group">
                                <input
                                  type="number"
                                  value={minimumOrderQuantity}
                                  onChange={(e) =>
                                    setMinimumOrderQuantity(e.target.value)
                                  }
                                  min={1}
                                  placeholder="Minimum order quantity"
                                  className="input-wrap inapp-input"
                                />
                              </div>
                            )}
                          </div>
                          <div className="availability-group">
                            <span className="availability-label">
                              Availability
                            </span>
                            <div className="checkbox-radio-wrap">
                              <label>
                                <input
                                  type="radio"
                                  name="available"
                                  value="1"
                                  checked={availability === "1"}
                                  onChange={(e) =>
                                    setAvailability(e.target.value)
                                  }
                                />
                                In stock
                              </label>
                            </div>
                            <div className="checkbox-radio-wrap">
                              <label>
                                <input
                                  type="radio"
                                  name="available"
                                  value="2"
                                  checked={availability === "2"}
                                  onChange={(e) =>
                                    setAvailability(e.target.value)
                                  }
                                />
                                Pre-order
                              </label>
                            </div>
                          </div>
                        </div>

                        {wholesaleProduct && availability === "2" && (
                          <div className="wholesale-details-row">
                            <div className="pre-order-dates-group">
                              <div className="form-group">
                                <label htmlFor="orderCutOffDate">
                                  Order cut-off date
                                  <span
                                    className="info-icon-wrapper"
                                    onMouseEnter={() => setShowOrderCutoffTooltip(true)}
                                    onMouseLeave={() => setShowOrderCutoffTooltip(false)}
                                    aria-label="Order cut-off date info"
                                  >
                                    <InfoIcon />
                                  </span>
                                </label>
                                {showOrderCutoffTooltip && (
                                  <div className="info-tooltip">
                                    <p>
                                      NB: Customers cannot pre-order this item after the order cut-off date.{" "}
                                    </p>
                                  </div>
                                )}
                                <DatePicker
                                  selected={orderCutOffDate}
                                  onChange={(date: any) => {
                                    setOrderCutOffDate(date);
                                  }}
                                  minDate={new Date()}
                                  name="orderCutOffDate"
                                  placeholderText="Select order cut-off date"
                                  className="input-wrap inapp-input"
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="expectedFulfillmentDate">
                                  Expected delivery date
                                  <span
                                    className="info-icon-wrapper"
                                    onMouseEnter={() => setShowExpectedAvailabilityTooltip(true)}
                                    onMouseLeave={() => setShowExpectedAvailabilityTooltip(false)}
                                    aria-label="Expected delivery date info"
                                  >
                                    <InfoIcon />
                                  </span>
                                </label>
                                {showExpectedAvailabilityTooltip && (
                                  <div className="info-tooltip">
                                    <p>
                                      The date this item is expected to arrive in your store.
                                    </p>
                                  </div>
                                )}
                                <DatePicker
                                  selected={expectedAvailabilityDate}
                                  onChange={(date: any) => {
                                    setExpectedAvailabilityDate(date);
                                  }}
                                  minDate={orderCutOffDate || new Date()}
                                  name="expectedFulfillmentDate"
                                  placeholderText="Select expected delivery date"
                                  className="input-wrap inapp-input"
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>


                      <div className="two-sided">
                        <div className="form-group thin-bordered-box variant-section-full-width">
                          <div className="eligible-btn-wrapper">
                            <div className="checkbox-radio-wrap">
                              <label>
                                <input
                                  type="checkbox"
                                  checked={eligibleForReturn}
                                  onChange={(e) =>
                                    setEligibleForReturn(e.target.checked)
                                  }
                                  id="eligibleForReturn-top"
                                />
                                Eligible for return
                              </label>
                            </div>

                            <select
                              className="input-wrap select"
                              disabled={!eligibleForReturn}
                              value={eligibleForReturnOption}
                              onChange={(e) =>
                                setEligibleForReturnOption(e.target.value)
                              }
                            >
                              <option value="0">Select an option</option>
                              <option value="0">For 3 days.</option>
                              <option value="1">For 7 days.</option>
                            </select>
                          </div>
                        </div>
                        <div className="form-group thin-bordered-box variant-section-full-width">
                          <div className="variant-btn-wrapper">
                            <div className="checkbox-radio-wrap">
                              <label className="variant-toggle-label">
                                <input
                                  type="checkbox"
                                  checked={addVariant}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    setAddVariant(isChecked);

                                    if (isChecked) {
                                      clearProductDiscountState(
                                        setFieldValue,
                                      );
                                      return;
                                    }

                                    setAttributes([]);
                                    setVariants([]);
                                    setEditingVariantIndex(null);
                                    setVariantToEdit(null);
                                    setShowAddEditVariantPopup(false);
                                  }}
                                  id="addVariant-top"
                                />
                                Add/edit variants
                                {variants.length > 0 ? (
                                  <span className="variant-count-badge">
                                    {variants.length}
                                  </span>
                                ) : null}
                              </label>
                            </div>
                            <div>
                              <button
                                type="button"
                                className="input-wrap"
                                disabled={!addVariant}
                                onClick={() =>
                                  openVariantModal(values.productName)
                                }
                              >
                                + Add variants option
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        )}
      </div>
      {/* } */}
      {pageProps.getProductMetaDataRequest.request_status ===
        "GET_PRODUCT_META_PENDING" && <LoadingItem />}
    </div>
  );
};

export const MainHeader = () => {
  return (
    <div className="product-info-header">
      <div
        className="left-nav"
        onClick={() => history.replace("/app/my-products")}
      >
        {" "}
        <img src={LeftArrow} alt="" />{" "}
      </div>
      <div className="other-item-wrap">
        <div className="heading-text">Edit Product</div>
        <div className="heading-msg">
          Edit your product to your store by filling out the necessary
          information below
        </div>
      </div>
    </div>
  );
};

export const getProductDetail = async ({ pageProps, payload }: any) => {
  await pageProps.getAProduct(payload);
};

export const getMetadata = async ({ pageProps, payload }: any) => {
  await pageProps.getMetadataAction(payload);
};

export const addNewProduct = async ({ pageProps, payload }: any) => {
  await pageProps.updateProductAction(payload);
};

export const editProduct = async ({ pageProps, payload }: any) => {
  await pageProps.updateProductAction(payload);
};

export const uploadProductImage = async ({
  pageProps,
  payload,
  otherNames,
}: any) => {
  await pageProps.uploadProductImageAction(payload, otherNames);
};

export const getImagesGallery = async ({ pageProps, payload }: any) => {
  await pageProps.getImageGalleryAction(payload, false);
};

export const getMoreImages = async ({ pageProps, payload }: any) => {
  await pageProps.getImageGalleryAction(payload, true);
};
